<style lang="less" scoped>
@import url('../../../style/common/variable.less');
.tabsCard {position: relative;text-align: left;font-family: AlibabaPuHuiTi-Regular;width: 1200px;height: 380px;margin: 15px auto;background-color: white;}
.content {margin-top: 6px;width: 1200px;;}
 /deep/.el-tabs__item {font-size: 20px !important;color: #aaaaaa;}
 /deep/.el-tabs__item.is-active{color: #05a1f5;}
 /deep/.el-tabs__active-bar{background: #05a1f5;}
.el-tab-pane {font-size: 16px;width: 1200px;}
.cardlist{display:flex;width:1200px;height: 430px;justify-content: space-between;}
.card1, .card2, .card3{width: 375px;height: 414px;border: 2px solid rgb(223, 220, 220);box-shadow: 2px 2px 2px 2px rgb(233, 230, 230);border-radius: 5px;overflow: hidden;}
i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 5px;font-size: 20px;color: rgb(25, 159, 248);}
.type{margin: 0px;width:100%;height: 40px;border-bottom:2px solid #e9e6e6;line-height:20px;
  .left{float: left;margin:15px 10px;
    span{font-size: 18px;font-weight: 600;}}
  .right{float: right;cursor: pointer;margin:15px 10px;
    span{font-size: 14px;font-weight: 600;color: rgb(49, 49, 49);}
    span:hover{color: #096eda}
  }
}
ul{list-style:none;margin-left: -1px;padding:0px 10px;height: 358px;}
li {position: relative;display: block;margin:3px;padding:0px;overflow: hidden;cursor: pointer;}
li:hover {.title{color: #13569e;}}
div, p {margin:0px;padding:0px;}
.titletime{display: flex;justify-content: space-between;}
.titleFirst {font-size: 14px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #333;width: 350px; height: 45px;line-height: 40px;}
.time{font-size: 14px;line-height: 40px;}
.titleFirst::before{content: "●";margin-right: 5px;color:rgb(186, 186, 185);}
.box {position: absolute;overflow: hidden;height: 0;top: 0;left: 0;transition: height 0.6s;background: #ffffff;}
.picBox {float: left;width: 100px;height: 70px;overflow: hidden;border: 1px solid #bbeaff;}
img {border: none;vertical-align: top;width: 100%;transition: transform .5s;}
img:hover {transform: scale(1.4,1.2)}
.textBox {float: left;margin-top: -60px;margin-left: 110px;}
.title {overflow: hidden;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;text-overflow: ellipsis;font-size: 14px;color: #333;width: 240px;}
li:nth-child(1) {height: 70px;.title{font-weight: 600;}}
li:nth-child(1) .box {height: 70px;}
li:hover {height: 70px;}
li:hover .box {height: 70px;}
.newky{position: absolute; right: 10px;top: 7px;font-size: 20px;font-weight: bold;cursor: pointer;z-index: 99;}
/deep/.el-tabs__nav {margin-left: 12px;}
@media screen and (max-width: @max-screen){
  .tabsCard{display: flex; align-content: center; flex-direction: column; flex-wrap: wrap; width: 96vw; height: auto;
    .cardlist{display: flex; flex-wrap: wrap; margin-left: 2vw; width: 100vw; height: auto;
      .card1, .card2, .card3{width: 96vw;}
    }
  }
}
</style>

<template>
  <div class="tabsCard">
        <div class="cardlist">
          <div class="card1">
            <div class="type">
              <div class="left"><i class="iconfont icon-guoneiyou"/><span>会员章程</span></div>
              <div class="right" @click = getMore()><span>更多 >></span></div>
            </div>
            <ul>
              <li v-for="(citem, cindex) in tabsCardGNZX" :key="cindex" @click="goDetails(citem)">
                <div class="titletime">
                  <p class="titleFirst">{{ citem.title }}</p>
                  <!-- <p class="time">{{ citem.addtime * 1000 | formatDateYM() }}</p> -->
                </div>
                <div class="box">
                  <div class="picBox">
                    <img v-if="citem.thumb !== ''" :src="citem.thumb">
                    <img v-if="citem.thumb === ''" src="static/images/moren.jpg">
                  </div>
                  <div class="textBox">
                    <p class="title"> {{ citem.title }} </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="card2">
            <div class="type">
              <div class="left"><i class="iconfont icon-zixun"/><span>通知公告</span></div>
              <div class="right" @click = getMores()><span>更多 >></span></div>
            </div>
            <ul>
              <li v-for="(citem, cindex) in tabsCardDMZX" :key="cindex" @click="goDetails(citem)">
                <div class="titletime">
                  <p class="titleFirst">{{ citem.title }}</p>
                  <!-- <p class="time">{{ citem.addtime * 1000 | formatDateYM() }}</p> -->
                </div>
                <div class="box">
                  <div class="picBox">
                    <img v-if="citem.thumb !== ''" :src="citem.thumb">
                    <img v-if="citem.thumb === ''" src="static/images/moren.jpg">
                  </div>
                  <div class="textBox">
                    <p class="title"> {{ citem.title }} </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="card3">
            <div class="type">
              <div class="left"><i class="iconfont icon-guoji"/><span>会员动态</span></div>
              <div class="right" @click = getMoress()><span>更多 >></span></div>
            </div>
            <ul>
              <li v-for="(citem, cindex) in tabsCardGJZX" :key="cindex" @click="goDetails(citem)">
                <div class="titletime">
                  <p class="titleFirst">{{ citem.title }}</p>
                  <!-- <p class="time">{{ citem.addtime * 1000 | formatDateYM() }}</p> -->
                </div>
                <div class="box">
                  <div class="picBox">
                    <img v-if="citem.thumb !== ''" :src="citem.thumb">
                    <img v-if="citem.thumb === ''" src="static/images/moren.jpg">
                  </div>
                  <div class="textBox">
                    <span class="title">{{ citem.title }}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
  </div>
</template>

<script>
/**
* 何宽  2021.9.11
* 该tabs标签页组件使用场景：每个标题包含不同多个不同的内容（以列表的形式），
    鼠标点击标题，面板上的内容切换到对应的标题下的内容；
    鼠标点击 列表项，返回相应的对象给父组件
*/
import $ from 'jquery'
import filters from '../method/filter'

export default {
  mixins: [filters],
  props: {
    hyzjlist: {
    }
  },
  data()
  {
    return {
      activeName: '1',
      tabsCardTitle: [],
      tabsCardGNZX: [],
      tabsCardDMZX: [],
      tabsCardGJZX: [],
      cur: '0',
      hyzj: this.hyzjlist,
      zzid: ''
    }
  },
  created()
  {
    let geturl = window.location.href
    this.zzid = geturl.split('=')[1]
    this.getCate()
    this.gethyzj()
  },
  updated()
  {
    if (this.activeName !== this.cur)
    
      this.cur = this.activeName
      // this.getData(this.cur)
    
    $('.card1 ul li:nth-child(n+2)').mouseover(function()
    {
      $('.card1 ul li:nth-child(n+2) .title').css('font-weight', '600')
      $('.card1 ul li:nth-child(1)').css('height', '45px')
      $('.card1 ul li:nth-child(1) .box').css('height', '0')
    })
    $('.card1 ul li:nth-child(n+2)').mouseleave(function()
    {
      $('.card1 ul li:nth-child(1)').css('height', '70px')
      $('.card1 ul li:nth-child(1) .box').css('height', '70px')
    })

    $('.card2 ul li:nth-child(n+2)').mouseover(function()
    {
      $('.card2 ul li:nth-child(n+2) .title').css('font-weight', '600')
      $('.card2 ul li:nth-child(1)').css('height', '45px')
      $('.card2 ul li:nth-child(1) .box').css('height', '0')
    })
    $('.card2 ul li:nth-child(n+2)').mouseleave(function()
    {
      $('.card2 ul li:nth-child(1)').css('height', '70px')
      $('.card2 ul li:nth-child(1) .box').css('height', '70px')
    })
    $('.card3 ul li:nth-child(n+2)').mouseover(function()
    {
      $('.card3 ul li:nth-child(n+2) .title').css('font-weight', '600')
      $('.card3 ul li:nth-child(1)').css('height', '45px')
      $('.card3 ul li:nth-child(1) .box').css('height', '0')
    })
    $('.card3 ul li:nth-child(n+2)').mouseleave(function()
    {
      $('.card3 ul li:nth-child(1)').css('height', '70px')
      $('.card3 ul li:nth-child(1) .box').css('height', '70px')
    })
  },
  methods: {
    //获取矿业资讯的类别
    getCate()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 20, _exp: 'moduleid=18'}
      window.post.getPost(paras).then((ret) =>
      {
        this.tabsCardTitle = [{catid: '1', name: '最新资讯'}]
        ret.forEach(item =>
        {
          this.tabsCardTitle.push({catid: item.id.toString(), name: item.dispc})
        })
      })
    },
    gethyzj()
    {
      let geturl = window.location.href
      let paras = {cmd: 'query', _major: 11, _minor: 127, _exp: `organiseid in (${geturl.split('=')[1]}, 0) and catid = 448 and examine = 0`, orderby: 'orders ASC', init: 0, pageno: 1, pagesize: 8}
      window.post.getPost(paras).then((ret) =>
      {
        this.tabsCardGNZX  = ret[0].data
      })
      let paras1 = {cmd: 'query', _major: 11, _minor: 127, _exp: `organiseid in (${geturl.split('=')[1]}, 0) and catid = 449 and examine = 0`, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 8}
      window.post.getPost(paras1).then((ret) =>
      {
        this.tabsCardDMZX  = ret[0].data
      })
      let paras2 = {cmd: 'query', _major: 11, _minor: 127, _exp: `organiseid in (${geturl.split('=')[1]}, 0) and catid = 450 and examine = 0`, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 8}
      window.post.getPost(paras2).then((ret) =>
      {
        this.tabsCardGJZX  = ret[0].data
      })
    },
    // 点击更多，将跳转到矿业资讯列表页
    getMore()
    {
      let obj = {catid: 448, name: '会员章程', zzid: Number(this.zzid)}
      let url = this.$router.resolve({path: '/HyzjList', query: obj})
      window.open(url.href, '_blank')
    },
    getMores()
    {
      let obj = {catid: 449, name: '通知公告', zzid: Number(this.zzid)}
      let url = this.$router.resolve({path: '/HyzjList', query: obj})
      window.open(url.href, '_blank')
    },
    getMoress()
    {
      let obj = {catid: 450, name: '会员动态', zzid: Number(this.zzid)}
      let url = this.$router.resolve({path: '/HyzjList', query: obj})
      window.open(url.href, '_blank')
    },
    // 点击新闻，跳转到新闻详情页面
    goDetails(citem)
    {
      let url = this.$router.resolve({path: '/HyzjDetails', query: {id: citem.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/TabsCardZz.vue